<template>
  <Form ref="dictTypeForm" :model="dictType" v-loading="loading" :disabled="actionType=='detail'" :rules="ruleValidate" :label-width="100" >
     <input v-model="dictType.id" type="hidden"/>

    <FormItem  :label="this.$t('system.dict-type.label.label')" prop="label">
      <Input v-model="dictType.label" :placeholder="$t('system.dict-type.label.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('system.dict-type.sign.label')" prop="sign">
      <Input v-model="dictType.sign" :placeholder="$t('system.dict-type.sign.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('system.dict-type.status.label')" prop="status">
      <Select v-model="dictType.status" :placeholder="$t('system.dict-type.status.holder')">
        <Option v-for="item in $t('system.dict-type.status.dictionary')" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
    </FormItem>

    <FormItem  :label="this.$t('system.dict-type.remark.label')" prop="remark">
      <Input v-model="dictType.remark" :placeholder="$t('system.dict-type.remark.holder')"  type="textarea" :rows="3"/>
    </FormItem>

  </Form>
</template>
<script>
import api from '@/api'

export default {
  data () {
    return {
      dictType: {
        id: null,
        label: null,
        sign: null,
        status: 1,
        remark: null,
        createTime: null,
        updateTime: null,
        deleted: 0
      },
      loading: false,
      actionType:'add'
    }
  },
  methods: {
    handleSubmit(then,error){
      this.$refs['dictTypeForm'].validate(valid => {
        if (valid) {
          if (this.dictType.id) {
            this.updateDictType(this.dictType).then(then).error(error)
          } else {
            this.createDictType(this.dictType).then(then).error(error)
          }
        } else {
          this.$Message.error(this.$t('errorText'))
          error()
        }
      })
    },
    handleReset(){
      this.dictType.id = ''
      this.actionType = 'add';
      this.$nextTick(()=>this.$refs['dictTypeForm'].resetFields());
    },
    getDictType(id,type){
      this.loading = true;
      this.$refs['dictTypeForm'].resetFields()
      api.system.DictType.detail(id).then(data => {
        this.dictType = data;
        this.loading = false;
        this.actionType = type;
      }).catch(e => this.loading = false)
    },
    createDictType(dictType){
      this.loading = true;
      return api.system.DictType.add(dictType)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    },
    updateDictType(dictType){
      this.loading = true;
      return api.system.DictType.update(dictType)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    }
  },
  computed: {
    ruleValidate(){
      let validate =  {
      label: [{type: 'string', required: true, message: this.$t('system.dict-type.label.required'),trigger: 'blur'}, {type: 'string',max: 100, message: this.$t('system.dict-type.label.max'),trigger: 'blur'}],
      sign: [{type: 'string', required: true, message: this.$t('system.dict-type.sign.required'),trigger: 'blur'}, {type: 'string',max: 100, message: this.$t('system.dict-type.sign.max'),trigger: 'blur'}],
      status: [{type: 'number', required: true, message: this.$t('system.dict-type.status.required'),trigger: 'blur'}],
      remark: [{type: 'string',max: 500, message: this.$t('system.dict-type.remark.max'),trigger: 'blur'}]
      }
      if(this.actionType == 'edit'){
        this.$refs['dictTypeForm'].fields.forEach(f => {
          if(f.$children[0].disabled){
            delete validate[f.prop]
          }
        })
      }else if(this.actionType == 'detail'){
        return {}
      }
      return validate;
    }
  }
}
</script>
